import * as React from 'react';
import { UNLEASH_FEATURE_NAMES } from '../../shared/unleash/feature-names';
import { getFeatureStatus } from '../config';
import { useShowTag } from '../hooks/ad';

export type Props = {
    id: string;
    targetId: string;
    pageType?: string;
    className?: string;
    deviceType?: string;
    proximity?: number;
    threshold?: number;
};

export function Banner(props: Props) {
    const {
        id,
        targetId,
        pageType,
        deviceType,
        className = 'ads__unit ads__unit--banner ads__unit--fullwidth',
        proximity = 100,
    } = props;
    const isBapHack =
        typeof window !== 'undefined' && window.location.href.includes('bap');
    const isTorgetObjectMobile =
        deviceType === 'mobile' &&
        isBapHack &&
        pageType === 'object' &&
        isBapHack;

    const proximityZeroBannerExperiment =
        getFeatureStatus(UNLEASH_FEATURE_NAMES.enableProximityIsZeroBanner) &&
        isTorgetObjectMobile;

    const _proximity = proximityZeroBannerExperiment ? 0 : proximity;

    useShowTag(targetId, _proximity);
    if (pageType && pageType === 'object') {
        // Rendered from mfinn already
        return <div />;
    }
    return (
        <div id={`${targetId}-container`} className={className}>
            <div
                id={targetId}
                className={`inline-container ${id}-inline-container`}
            >
                <span className="ad-info-wrap">
                    <div id={`${targetId}-button`} className="ad-info" />
                </span>
            </div>
        </div>
    );
}
